import Vue from 'vue'
import Router from 'vue-router'

// store
import store from '@/store/index'
import constPage from "../../definition/const/const_page";

// Containers
const TheContainer = () => import('@/containers/TheContainer')


// Views
const TopPage = () => import('@/views/TopPage')
const Account = () => import('@/views/profile/Account')
const Careers = () => import('@/views/career/Careers')
const CareerEditing = () => import('@/views/career/CareerEditing')
const Profile = () => import('@/views/career/Profile')
const MajorAchievements = () => import('@/views/career/MajorAchievements')
const JobCareer = () => import('@/views/career/jobCareer/JobCareer')
const UserMaster = () => import('@/views/master/user/UserMaster')
const OrganizationMaster = () => import('@/views/master/organizations/OrganizationMaster')
const PositionMaster = () => import('@/views/master/position/PositionMaster')
const AuthorityMaster = () => import('@/views/master/authority/AuthorityMaster')
const SkillMaster = () => import('@/views/master/skill/SkillMaster')
const QualificationMaster = () => import('@/views/master/qualification/QualificationMaster')
const QualificationInfo = () => import('@/views/users/QualificationInfoList')
const SkillInfo = () => import('@/views/users/SkillInfoList')

// Login
const Login = () => import('@/views/login/Login')

// Views - Errors
const Page400 = () => import('@/views/errors/Page400')
const Page404 = () => import('@/views/errors/Page404')
const Page500 = () => import('@/views/errors/Page500')

Vue.use(Router)

const routes = [
  {
    path: '/',
    name: 'Login',
    meta: { pageId: constPage.LOGIN, isPublic: true },
    component: Login
  },
  {
    path: '/',
    redirect: '/top-page',
    name: '',
    meta: { pageId: constPage.TOPPAGE },
    component: TheContainer,
    children: [
      {
        path: 'top-page',
        redirect: '/top-page',
        name: 'トップページ',
        meta: { pageId: constPage.TOPPAGE },
        component: {
          render(c) { return c('router-view') }
        },
        children: [
          {
            path: '',
            meta: { pageId: constPage.TOPPAGE },
            component: TopPage
          },
          {
            path: 'profile',
            redirect: '/top-page/profile/accounts',
            name: 'プロフィール',
            component: {
              render(c) { return c('router-view') }
            },
            children: [
              {
                path: 'accounts',
                name: 'アカウント情報',
                component: Account
              },
              {
                path: 'careerEditing',
                name: '経歴情報',
                meta: { pageId: constPage.CAREER_EDITING },
                component: CareerEditing
              },
              {
                path: 'profile',
                name: '概要',
                component: Profile
              },
              {
                path: 'majorAchievements',
                name: '主要実績',
                component: MajorAchievements
              },
              {
                path: 'jobCareer',
                name: '職務経歴',
                component: JobCareer
              }
            ]
          },
          {
            path: 'careers',
            name: '経歴一覧',
            meta: { pageId: constPage.CAREERS },
            component: Careers
          },
          {
            path: 'careers',
            component: {
              render(c) {
                return c('router-view')
              }
            },
            children: [
              {
                path: ':id',
                name: 'careerEditing',
                meta: { pageId: constPage.CAREER_EDITING, label: 'User Details' },
                component: CareerEditing
              },
            ]
          },
          {
            path: 'qualificationinfo',
            name: '個人資格情報一覧',
            meta: { pageId: constPage.QUALIFICATIONINFO },
            component: QualificationInfo
          },
          {
            path: 'qualificationinfo',
            component: {
              render(c) {
                return c('router-view')
              }
            }
          },
          {
            path: 'skillinfo',
            name: '個人スキル情報一覧',
            meta: { pageId: constPage.SKILLINFO },
            component: SkillInfo
          },
          {
            path: 'skillinfo',
            component: {
              render(c) {
                return c('router-view')
              }
            }
          },
          {
            path: 'master',
            name: 'マスタメンテナンス',
            redirect: '/top-page/master/users',
            component: {
              render(c) { return c('router-view') }
            },
            children: [
              {
                path: 'users',
                name: 'ユーザー',
                meta: { pageId: constPage.USER_MASTER },
                component: UserMaster
              },
              {
                path: 'organizations',
                name: '組織',
                meta: { pageId: constPage.ORGANIZATION_MASTER },
                component: OrganizationMaster
              },
              {
                path: 'positions',
                name: '役職',
                meta: { pageId: constPage.POSITION_MASTER },
                component: PositionMaster
              },
              {
                path: 'authorities',
                name: '閲覧権限',
                meta: { pageId: constPage.AUTHORITY_MASTER },
                component: AuthorityMaster
              },
              {
                path: 'skills',
                name: 'スキル',
                meta: { pageId: constPage.SKILL_MASTER },
                component: SkillMaster
              },
              {
                path: 'qualifications',
                name: '資格',
                meta: { pageId: constPage.QUALIFICATION_MASTER },
                component: QualificationMaster
              }
            ]
          }
        ]
      }
    ]
  },
  {
    path: '/errors',
    redirect: '/errors/400',
    name: 'Errors',
    component: {
      render(c) { return c('router-view') }
    },
    children: [
      {
        path: '400',
        name: 'Page400',
        component: Page400
      },
      {
        path: '404',
        name: 'Page404',
        component: Page404
      },
      {
        path: '500',
        name: 'Page500',
        component: Page500
      }
    ]
  }
];

const router = new Router({
  mode: 'hash', // https://router.vuejs.org/api/#mode
  linkActiveClass: 'active',
  scrollBehavior: () => ({ y: 0 }),
  base: process.env.BASE_URL,
  routes,
  store
});

router.beforeEach((to, from, next) => {
  // isPublicがtrue(認証不要)、もしくは遷移先の画面表示権限があれば、そのまま遷移する
  if (to.meta.isPublic || hasViewAuthority(to, store)) {
    // 次のルート
    next();
  } else {
    // 画面表示権限がなければログイン画面に遷移
    // TODO:ログイン状態だとトップページに自動で遷移するが問題ないか要確認
    next({ name: 'Login' });
  }
});

// 対象画面の表示権限判定
function hasViewAuthority(to, store) {
  // ログインしていなければfalse
  if (!store.state.islogin) return false;
  // 画面ID設定がなければtrue
  if (typeof to.meta.pageId === "undefined") return true;
  const authorityId = store.state.loginUser.p_authorities.find(
    (a) => a.page_id === to.meta.pageId
  ).operation_authority;
  // 操作権限が0（権限無し）以上ならtrue
  return authorityId > 0;
}

export default router